export enum TrustPilotType {
  SLIDER = "SLIDER",
  MICRO = "MICRO",
  MINI = "MINI",
}

export enum TrustPilotTheme {
  LIGHT = "light",
  DARK = "dark",
}

export interface TrustPilotWidgetProps {
  trustPilotType: TrustPilotType;
  trustPilotTheme?: TrustPilotTheme;
  height?: string;
}

export interface TrustPilotWidgetConfig {
  dataTemplateId: string;
  dataBusinessUnitId: string;
  dataTemplateHeight: string;
  url: string;
}
